export default __webpack_public_path__ + "static/media/landscape13.c53e64c7.jpeg";